var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAuditTrailSideMenuIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 20,
  fill: "none",
  viewBox: "0 0 19 20",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#49475A",
  d: "M0 .5v15.482h12.525l2.886 2.884c.423.423.95.634 1.478.634s1.055-.211 1.477-.634c.423-.422.634-.95.634-1.477s-.211-1.055-.634-1.478l-2.884-2.886V.5zm1.407 1.407h12.667v9.71l-1.196-1.195-3.73-.774.774 3.73 1.196 1.196h-9.71zM3.52 4.02v1.407h8.444V4.019zm0 2.814v1.408h5.63V6.833zm7.458 4.644 1.198.212 5.206 5.208a.68.68 0 0 1 0 .984.68.68 0 0 1-.984 0l-5.208-5.206z"
})));
export { SvgAuditTrailSideMenuIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/audit-trail-side-menu-icon.svg";